import './recorder'
import './surveys'
import './logs'
import './exception-autocapture'
import './tracing-headers'
import './web-vitals'
import './dead-clicks-autocapture'
